import React from 'react';
import { Modal as BaseModal } from 'antd';

const Modal = ({ title = false, footer = false, children, onClick, ...rest }) => (
	<BaseModal
		cancelButtonProps={{ style: { display: 'none' } }}
		title={title}
		footer={footer}
		maskClosable={true}
		destroyOnClose={true}
		{...rest}
	>
		{children}
	</BaseModal>
);
export default Modal;
